// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"874":"fdc8a117","1100":"fdc8a117","2169":"fdc8a117","2783":"fdc8a117","2868":"fdc8a117","6005":"fdc8a117","8022":"fdc8a117","8977":"fdc8a117","9978":"fdc8a117"}[chunkId] + ".chunk.css";
};